// Generated types for Port
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { PortDirection } from '../enums';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PortReadAPI extends RFLPElementReadAPI {
  /** IN | OUT | INOUT — valid connection directionality. */
  direction?: PortDirection;
  /** Explicitly unconnected. Completeness rules skip floating ports. */
  is_floating?: boolean;
  /** Why the port is marked floating (documentation for reviewers). */
  floating_rationale?: string | null;
}

export interface PortWriteAPI extends RFLPElementWriteAPI {
  /** IN | OUT | INOUT — valid connection directionality. */
  direction?: PortDirection;
  /** Explicitly unconnected. Completeness rules skip floating ports. */
  is_floating?: boolean;
  /** Why the port is marked floating (documentation for reviewers). */
  floating_rationale?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PortReadAPISchemaObject = RFLPElementReadAPISchemaObject.extend({
  direction: z.nativeEnum(PortDirection).optional(),
  is_floating: z.boolean().optional(),
  floating_rationale: z.string().nullable().optional(),
}).passthrough();
export const PortReadAPISchema: z.ZodType<PortReadAPI> = PortReadAPISchemaObject;

export const PortWriteAPISchemaObject = RFLPElementWriteAPISchemaObject.extend({
  direction: z.nativeEnum(PortDirection).optional(),
  is_floating: z.boolean().optional(),
  floating_rationale: z.string().nullable().optional(),
}).passthrough();
export const PortWriteAPISchema: z.ZodType<PortWriteAPI> = PortWriteAPISchemaObject;
